import React, { PureComponent } from 'react';
import orderBy from 'lodash/orderBy';

import { withRouter } from 'react-router';
// import { css } from 'react-emotion';
import { compose, graphql } from 'react-apollo';
import gql from 'graphql-tag';
import Loading from '../../components/Loading';
// import AddCardButton from '../../views/Admin/ModalButtons/AddCard';
import CreditCardItem from '../../views/Admin/CreditCardItem';
import PurchaseOrderItem from '../../views/Admin/PurchaseOrderItem';
import '../../styles/Stripe.css';

const queryCards = gql`
  query cards($organizationId: ID!) {
    cards(organizationId: $organizationId) {
      id
      organization_id
      brand
      last4
      exp_month
      exp_year
      is_default
    }
  }
`;

const queryPurchaseOrders = gql`
  query purchaseOrders($organizationId: ID!) {
    purchaseOrders(organizationId: $organizationId) {
      id
      organization_id
      props
    }
  }
`;

const updateCard = gql`
  mutation updateCard($cardId: ID!, $card: CardInput!) {
    updateCard(cardId: $cardId, card: $card) {
      id
      organization_id
      brand
      last4
      exp_month
      exp_year
      is_default
    }
  }
`;

const deleteCard = gql`
  mutation deleteCard($cardId: ID!) {
    deleteCard(cardId: $cardId) {
      id
    }
  }
`;

const withData = compose(
  graphql(queryCards, {
    name: 'cardsQuery',
    options: ({ params }) => ({
      variables: {
        organizationId: params.organizationId,
      },
      fetchPolicy: 'network-only',
    }),
  }),
  graphql(queryPurchaseOrders, {
    name: 'purchaseOrdersQuery',
    options: ({ params }) => ({
      variables: {
        organizationId: params.organizationId,
      },
      fetchPolicy: 'network-only',
    }),
  }),
  graphql(updateCard, {
    props: ({ mutate, ownProps }) => ({
      updateCard: values => {
        return mutate({
          variables: values,
          update: (proxy, { data: { updateCard } }) => {
            const data = proxy.readQuery({
              query: queryCards,
              variables: { organizationId: ownProps.params.organizationId },
            });

            proxy.writeQuery({
              query: queryCards,
              variables: { organizationId: ownProps.params.organizationId },
              data: {
                ...data,
                cards: orderBy(
                  [
                    ...data.cards.map(c => ({
                      ...c,
                      is_default: c.id === updateCard.id ? true : false,
                    })),
                  ],
                  ['id'],
                  ['desc'],
                ),
              },
            });
          },
        });
      },
    }),
  }),
  graphql(deleteCard, {
    props: ({ ownProps: { params }, mutate }) => ({
      deleteCard: values => {
        return mutate({
          variables: values,
          update: (proxy, { data: { deleteCard } }) => {
            const data = proxy.readQuery({
              query: queryCards,
              variables: { organizationId: params.organizationId.toString() },
            });
            proxy.writeQuery({
              query: queryCards,
              variables: { organizationId: params.organizationId.toString() },
              data: {
                cards: data.cards.filter(card => card.id !== deleteCard.id),
              },
            });
          },
        });
      },
    }),
  }),
);

@withRouter
@withData
class OrganizationBilling extends PureComponent {
  state = {
    isSettingDefault: {},
    isDeleting: {},
  };

  handleDeleteCard = async cardId => {
    const { deleteCard } = this.props;
    this.setState({ isDeleting: { [cardId]: true }});
    await deleteCard({ cardId });
    this.setState({ isDeleting: { [cardId]: false }});
  };

  handleSetDefault = async card => {
    const { updateCard } = this.props;
    const cardId = card.id;
    this.setState({ isSettingDefault: { [cardId]: true }});
    await updateCard({ cardId, card: { isDefault: true } });
    this.setState({ isSettingDefault: { [cardId]: false }});
  };

  render() {
    const { cardsQuery: { cards, loading }, purchaseOrdersQuery } = this.props;
    if (loading || purchaseOrdersQuery.loading) return <Loading />;
    const sortedCards =
      cards && orderBy(cards, [c => parseInt(c.id, 10)], ['desc']);
    const purchaseOrders = purchaseOrdersQuery.purchaseOrders || [];

    return (
      <div>
        <h1>Billing</h1>
        {/* <AddCardButton /> */}
        <ul className="list-group mt-2">
          {sortedCards &&
            sortedCards.map((card, idx) => {
              return (
                <CreditCardItem
                  key={idx}
                  card={card}
                  isSettingDefault={this.state.isSettingDefault[card.id]}
                  isDeleting={this.state.isDeleting[card.id]}
                  deleteCard={this.handleDeleteCard}
                  handleSetDefault={this.handleSetDefault}
                />
              );
            })}
        </ul>
        <ul className="list-group">
          {purchaseOrders.map((po, idx) => {
            return (
              <PurchaseOrderItem
                key={idx}
                purchaseOrder={po}
              />
            );
          })}
        </ul>
      </div>
    );
  }
}

export default class OrganizationBillingContainer extends PureComponent {
  render() {
    const { params: { accountId } } = this.props;
    return <OrganizationBilling {...this.props} accountId={accountId} />;
  }
}



// WEBPACK FOOTER //
// ./src/views/Organization/OrganizationBilling.js